interface LocalPeerSession {
  owns(peerId: string): boolean;
  ownsVideoPeer(peerId: string): boolean;
  onConnected(peerId: string): void;
  onDisconnected(peerId: string): void;
}
interface LocalPeerTransport { disconnectLocalPeer(peerId: string): void }

/** A retired local video peer must never acquire remote admin desktop control. */
export class LocalHostPeerBoundary {
  public constructor(private readonly transport: LocalPeerTransport, private readonly session?: LocalPeerSession) {}
  public static isLocalPeer(peerId: string): boolean { return peerId.startsWith('local-editor:'); }
  public blocksControl(peerId: string): boolean {
    return LocalHostPeerBoundary.isLocalPeer(peerId) || !!this.session?.owns(peerId);
  }
  public connected(peerId: string): boolean {
    if (!this.blocksControl(peerId)) return false;
    if (this.session?.ownsVideoPeer(peerId)) this.session.onConnected(peerId);
    else this.transport.disconnectLocalPeer(peerId);
    return true;
  }
  public disconnected(peerId: string): boolean {
    if (!this.blocksControl(peerId)) return false;
    if (this.session?.ownsVideoPeer(peerId)) this.session.onDisconnected(peerId);
    return true;
  }
  public message(peerId: string, dispatch: () => void): boolean {
    if (!LocalHostPeerBoundary.isLocalPeer(peerId)) return false;
    if (this.session?.ownsVideoPeer(peerId)) dispatch();
    else this.transport.disconnectLocalPeer(peerId);
    return true;
  }
}
